export const SIGN_PATH = '/sign'
export const DEFAULT_POST_LOGIN_PATH = '/index'
export const SESSION_EXPIRED_REASON = 'session-expired'

let activeAuthPrompt = null

function normalizeRoute(route) {
  return route || {}
}

export function resolveRouteRedirect(route) {
  const currentRoute = normalizeRoute(route)
  const path = currentRoute.path || ''

  if (!path || path === SIGN_PATH) {
    return ''
  }

  return currentRoute.fullPath || path
}

export function buildSignRoute(route, reason) {
  const query = {}
  const redirect = resolveRouteRedirect(route)

  if (redirect) {
    query.redirect = redirect
  }

  if (reason) {
    query.reason = reason
  }

  return {
    path: SIGN_PATH,
    query
  }
}

export function resolvePostLoginPath(route) {
  const currentRoute = normalizeRoute(route)
  const redirect = currentRoute.query && currentRoute.query.redirect

  if (typeof redirect === 'string' && redirect.indexOf('/') === 0 && redirect !== SIGN_PATH) {
    return redirect
  }

  return DEFAULT_POST_LOGIN_PATH
}

export function promptForSessionRecovery(showConfirm) {
  if (activeAuthPrompt) {
    return activeAuthPrompt
  }

  activeAuthPrompt = Promise.resolve()
    .then(() => showConfirm())
    .then(() => true)
    .catch(() => false)
    .then(result => {
      activeAuthPrompt = null
      return result
    })

  return activeAuthPrompt
}

export function logoutAndRedirectToSign({ store, router, route, reason }) {
  const redirectRoute = buildSignRoute(route || (router && router.currentRoute), reason)

  return Promise.resolve()
    .then(() => store.dispatch('SetRole', 0))
    .catch(error => {
      console.error('Failed to reset role during logout redirect', error)
    })
    .then(() => store.dispatch('LogOut'))
    .catch(error => {
      console.error('Failed to clear local session during logout redirect', error)
    })
    .then(() => {
      if (router) {
        return router.replace(redirectRoute)
      }

      return undefined
    })
}

export function createAuthExpiredError(code) {
  const error = new Error(code || 'AUTH_EXPIRED')
  error.code = code || 'AUTH_EXPIRED'
  return error
}

export function handleSessionExpired({ store, router, route, showConfirm }) {
  return promptForSessionRecovery(showConfirm)
    .then(confirmed => {
      if (!confirmed) {
        throw createAuthExpiredError('AUTH_EXPIRED_CANCELLED')
      }

      return logoutAndRedirectToSign({
        store,
        router,
        route,
        reason: SESSION_EXPIRED_REASON
      })
    })
    .then(() => {
      throw createAuthExpiredError('AUTH_EXPIRED_REDIRECTED')
    })
}
